import api from "../../utils/apiUserTienda";

export const getMarcas = async () => {
  const res = await api.get("/api/tienda/marcas/obtener");
  return res.data.data || [];
};

export const crearMarca = async (data) => {
  const isFormData = data instanceof FormData;

  const res = await api.post("/api/tienda/marcas/crear", data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });

  return res.data;
};

export const actualizarMarca = async (id, data) => {
  const isFormData = data instanceof FormData;

  const res = await api.put(`/api/tienda/marcas/actualizar/${id}`, data, {
    headers: isFormData ? { "Content-Type": "multipart/form-data" } : undefined,
  });

  return res.data;
};